import { render, staticRenderFns } from "./AutenticacaoDigital.vue?vue&type=template&id=3bc04283&"
import script from "./AutenticacaoDigital.vue?vue&type=script&lang=js&"
export * from "./AutenticacaoDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports